<!--
 * @Descripttion:
 * @version:
 * @Author: xiaona.wang
 * @Date: 2021-01-04 15:53:08
 * @LastEditors: xiaona.wang
 * @LastEditTime: 2022-01-11 16:13:07
-->
<template>
  <div class="settingPassword-container">
    <logo-head />
    <loading v-if="showFullLoading"></loading>
    <div v-show="!showSettingPassword" class="form-container">
      <div class="form-top">
        <img class="form-top-image" :src="showPicture" />
        <div class="form-top-right">
          <div class="form-top-letter-first">{{ $t("getBackPassword.validationTitle") }}</div>
          <div class="form-top-letter-second">{{ formTopTitle }}</div>
        </div>
      </div>
      <div class="switch-tab">
        <!-- <span :class="selectTag ? 'switch-tab-item' : 'switch-tab-active'" @click="selectPhone">
          {{ $t("getBackPassword.getBackPhone") }}
        </span>
        <span :class="selectTag ? 'switch-tab-active' : 'switch-tab-item'" @click="selectEmail">
          {{ $t("getBackPassword.getBackEmail") }}
        </span> -->
        <span class="switch-tab-active">
          {{ $t("getBackPassword.getBackEmail") }}
        </span>
      </div>
      <el-form ref="getCodeForm" class="validation" :rules="rules" :model="ruleForm">
        <span class="letter">{{ titleFirst }}</span>
        <el-form-item prop="target">
          <el-input v-model="ruleForm.target" class="input" type="text" :placeholder="inputTip" />
        </el-form-item>
        <span class="letter">{{ $t("getBackPassword.enterCode") }}</span>
        <el-form-item class="code-container" prop="verifyCode">
          <el-input
            v-model="ruleForm.verifyCode"
            class="input codeInput"
            type="text"
            :placeholder="$t('getBackPassword.enterCode')"
            maxlength="6"
          />
          <span class="getCode" @click="getCode">
            {{ codeType == "cellphone" ? showPhoneCountdown : showEmailCountdown }}
          </span>
        </el-form-item>
        <div class="alert-container">
          <img class="alert-image" src="@/assets/images/alert.png" alt="" />
          <span class="alert-text">{{ tipMessage }}</span>
        </div>
        <el-button
          :loading="loading"
          type="primary"
          class="button"
          :disabled="showValidationButton == false"
          @click="submit"
        >
          {{ $t("public.confirm") }}
        </el-button>
      </el-form>
    </div>
    <div v-show="showSettingPassword && !backToLogin" class="form-container">
      <div class="form_warp">
        <div class="warp_title">
          <svg-icon icon-class="change-pass" class="pass-icon"></svg-icon>
          <span class="warp_title_warp">
            <span class="context_title_h1">{{ $t("getBackPassword.setPassword") }}</span>
            <span>{{ $t("getBackPassword.fillPassword") }}</span>
          </span>
        </div>
        <el-form ref="formRef" class="set-new-password" :rules="formRules" :model="setPasswordForm">
          <el-form-item :label="$t('getBackPassword.setNewPassword')" prop="newPassword">
            <el-input
              v-model.trim="setPasswordForm.newPassword"
              show-password
              :placeholder="$t('getBackPassword.enterNewPassword')"
              autocomplete="off"
            />
          </el-form-item>
          <el-form-item :label="$t('getBackPassword.confirmNewPassword')" prop="confirmPassword">
            <el-input
              v-model.trim="setPasswordForm.confirmPassword"
              show-password
              :placeholder="$t('getBackPassword.reenterNewPassword')"
              autocomplete="off"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="footer_btn" :loading="loading" type="primary" @click="handleConfirm">
            {{ $t("public.confirm") }}
          </el-button>
        </div>
      </div>
    </div>
    <div v-show="backToLogin" class="form-container form-back-to-login">
      <div class="form_warp">
        <div class="warp_title">
          <svg-icon icon-class="change-pass" class="pass-icon"></svg-icon>
          <span class="warp_title_warp">
            <span class="context_title_h1">
              {{ $t("getBackPassword.passwordSettingFinished") }}
            </span>
            <span>{{ $t("getBackPassword.logInAgain") }}</span>
          </span>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button class="footer_btn" :loading="loading" type="primary" @click="backToLoginPage">
            {{ $t("login.logIn") }}
          </el-button>
        </div>
      </div>
    </div>
    <logo-footer />
  </div>
</template>

<script>
import LogoHead from "@/components/common/logoHead/index";
import imagePhone from "@/assets/images/forget-by-phone.png";
import imageEmail from "@/assets/images/forget-by-email.png";
import LogoFooter from "@/components/common/logoFooter/index";
import Loading from "@/components/common/Loading";
// import { forgetPassword } from "@/api/forgetPassword/forgetPassword";
import { validatePassword } from "@/utils/operation_validate";
import { validateEmail } from "@/utils/validate";

import { mapGetters } from "vuex";
export default {
  name: "SettingPassword",
  components: {
    LogoHead,
    LogoFooter,
    Loading
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("login.enterPassword")));
      } else {
        if (this.setPasswordForm.confirmPassword !== "") {
          this.$refs.formRef.validateField("checkPassword");
        }
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("getBackPassword.reenterNewPassword")));
      } else if (value !== this.setPasswordForm.newPassword) {
        callback(new Error("this.$t('getBackPassword.inconsistent')"));
      } else {
        callback();
      }
    };

    return {
      showValidationButton: false,
      backToLogin: false,
      showSettingPassword: false,
      formRules: {

        /*
         * oldPassword: [
         *   { required: true, message: "请输入登录密码", trigger: "blur" },
         * ],
         */
        newPassword: [
          { required: true, validator: validatePass, trigger: "blur" },
          { required: true, validator: validatePassword, trigger: "blur" }
        ],
        confirmPassword: [
          { required: true, validator: validatePass2, trigger: "blur" },
          { required: true, validator: validatePassword, trigger: "blur" }
        ]
      },
      rules: {
        target: [
          { required: true, message: this.$t("getBackPassword.enterEmail"), trigger: "blur" },
          { validator: validateEmail, trigger: ["blur"] }
        ],
        verifyCode: [
          { required: true, message: this.$t("getBackPassword.enterCode"), trigger: "blur" }
        ]
      },
      codeType: "email",
      // 表单绑定的对象
      ruleForm: {
        target: "",
        action: "auth.resetPassword",
        type: "email",
        verifyCode: ""
      },
      // 校验验证码的对象
      vaildForm: {
        action: "auth.resetPassword",
        target: "",
        verifyCode: ""
      },
      // 修改新密码绑定的对象
      setPasswordForm: {
        confirmPassword: "",
        newPassword: "",
        target: "",
        verifyCode: ""
      },
      // 强赋值的对象
      setBaseFrom: {},
      selectTag: false,
      loading: false,
      formTopTitle: this.$t("getBackPassword.formTopTitleEmail"),
      titleFirst: this.$t("getBackPassword.emailVerification"),
      inputTip: this.$t("getBackPassword.enterEmail"),
      tipMessage: this.$t("getBackPassword.NotEmails"),
      showPhoneCountdown: this.$t("login.getVerificationCode"),
      showEmailCountdown: this.$t("login.getVerificationCode"),
      isEmailCodeIng: false,
      isPhoneCodeIng: false,
      showPicture: Object
    };
  },
  mounted() {
    this.showPicture = imagePhone;
  },
  computed: {
    ...mapGetters(["showFullLoading"])
  },
  methods: {
    // 对密码进行编码
    encode(str) {
      // 对字符串进行编码
      const encode = encodeURI(str);
      // 对编码的字符串转化base64
      const base64 = btoa(encode);
      return base64;
    },
    selectPhone() {
      // 被选中状态，的界面文字和图片更改
      this.selectTag = false;
      this.formTopTitle = this.$t("getBackPassword.formTopTitlePhone");
      this.titleFirst = this.$t("getBackPassword.phoneVerification");
      this.inputTip = this.$t("getBackPassword.enterPhone");
      this.codeType = "cellphone";
      this.ruleForm.type = "cellphone";
      this.showPicture = imagePhone;
      this.ruleForm.verifyCode = "";
      this.ruleForm.target = "";
      this.tipMessage = this.$t("getBackPassword.NotSMS");
      this.$refs.getCodeForm.clearValidate();
    },
    selectEmail() {
      // 被选中状态，的界面文字和图片更改
      this.selectTag = true;
      this.formTopTitle = this.$t("getBackPassword.formTopTitleEmail");
      this.titleFirst = this.$t("getBackPassword.emailVerification");
      this.inputTip = this.$t("getBackPassword.enterEmail");
      this.codeType = "email";
      this.ruleForm.type = "email";
      this.showPicture = imageEmail;
      this.ruleForm.verifyCode = "";
      this.ruleForm.target = "";
      this.tipMessage = this.$t("getBackPassword.NotEmails");
      this.$refs.getCodeForm.clearValidate();
    },
    // 获取验证码倒计时
    getCode() {
      this.$refs.getCodeForm.validateField("target", emailError => {
        if (emailError) { return; }
        this.showValidationButton = true;
        this.isEmailCodeIng = true;
        let time = 60;
        const timer = setInterval(() => {
          time--;
          this.showEmailCountdown = `${this.$t("login.tryAgain") + time}s`;
          if (time <= 0) {
            this.showEmailCountdown = this.$t("login.getVerificationCode");
            this.isEmailCodeIng = false;
            clearInterval(timer);
          }
        }, 1000);
        forgetPassword
          .getVerificationCode(this.ruleForm)
          .then(res => {
            if (res.resultCode === 200) {
              // console.log(res)
            }
          })
          .catch(() => {
            // console.log('报错了')
          });
      });

      /*
       * if (this.ruleForm.target !== "") {
       *   if (this.codeType === "cellphone") {
       *     if (!this.isPhoneCodeIng) {
       *       this.showValidationButton = true;
       *       this.isPhoneCodeIng = true;
       *       let time = 60;
       *       const timer = setInterval(() => {
       *         time--;
       *         this.showPhoneCountdown = this.$t("login.tryAgain") + time + "s";
       *         if (time <= 0) {
       *           this.showPhoneCountdown = this.$t("login.getVerificationCode");
       *           this.isPhoneCodeIng = false;
       *           clearInterval(timer);
       *         }
       *       }, 1000);
       *       forgetPassword
       *         .getVerificationCode(this.ruleForm)
       *         .then((res) => {
       *           if (res.resultCode === 200) {
       *             // console.log('验证码发送成功');
       *           }
       *         })
       *         .catch(() => {
       *           // console.log('报错了')
       *         });
       *     }
       *   } else {
       *     if (!this.isEmailCodeIng) {
       *       this.showValidationButton = true;
       *       this.isEmailCodeIng = true;
       *       let time = 60;
       *       const timer = setInterval(() => {
       *         time--;
       *         this.showEmailCountdown = this.$t("login.tryAgain") + time + "s";
       *         if (time <= 0) {
       *           this.showEmailCountdown = this.$t("login.getVerificationCode");
       *           this.isEmailCodeIng = false;
       *           clearInterval(timer);
       *         }
       *       }, 1000);
       *       forgetPassword
       *         .getVerificationCode(this.ruleForm)
       *         .then((res) => {
       *           if (res.resultCode === 200) {
       *             // console.log(res)
       *           }
       *         })
       *         .catch(() => {
       *           // console.log('报错了')
       *         });
       *     }
       *   }
       * } else {
       *   this.$message.error(this.$t("getBackPassword.cannotEmpty"));
       * }
       */
    },
    submit() {
      this.$refs.getCodeForm.validate(valid => {
        if (valid) {
          // 提交验证码验证是否正确
          this.loading = true;
          this.vaildForm.target = this.ruleForm.target;
          this.vaildForm.verifyCode = this.ruleForm.verifyCode;
          this.vaildForm.type = this.ruleForm.type;
          forgetPassword
            .checkCode(this.vaildForm)
            .then(res => {
              if (res.data.valid === true) {
                this.showSettingPassword = true;
                this.setPasswordForm.target = this.vaildForm.target;
                this.setPasswordForm.verifyCode = this.vaildForm.verifyCode;
              } else {
                this.$message.error(this.$t("getBackPassword.verificationCodeError"));
              }
            })
            .catch(() => {
              // console.log('报错了')
            });
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        } else {
          return false;
        }
      });
    },
    handleConfirm() {
      this.setBaseFrom = JSON.parse(JSON.stringify(this.setPasswordForm));
      forgetPassword
        .resizePassword(this.setBaseFrom)
        .then(res => {
          if (res.resultCode === 200) {
            this.backToLogin = true;
          }
        })
        .catch(() => {
          // console.log('出错了')
        });
    },
    backToLoginPage() {
      this.ruleForm = {};
      this.setPasswordForm = {};
      this.vaildForm = {};
      this.$router.push({ path: "/login" });
    }
  }
};
</script>

<style lang="scss" scoped>
$weightText: #21252e;
.custom-theme {
  background-color: #f5f7fa !important;
}
.codeInput {
  position: absolute;
}
.code-container {
  position: relative;
}
.getCode {
  display: inline-block;
  position: relative;
  text-align: right;
  margin-top: 16px;
  padding-right: 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #00b259;
  cursor: pointer;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  float: right;
  &:before {
    content: "";
    position: absolute;
    left: -12px;
    width: 1px;
    height: 25px;
    top: 50%;
    transform: translateY(-50%);
    background: #cbd1de;
  }
}
.switch-tab {
  width: 410px;
  align-self: center;
  line-height: 40px;
  display: flex;
  margin-bottom: 38px;
  .switch-tab-item {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #21252e;
    flex: 1;
    text-align: center;
    border-bottom: 1px solid #ebecef;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
  .switch-tab-active {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    flex: 1;
    text-align: center;
    cursor: pointer;
    color: #00b259;
    border-bottom: 3px solid #00b259;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
}

.settingPassword-container {
  min-height: 100%;
  background-color: #f5f7fa;
  overflow: hidden;
  display: flex;
  justify-content: center;
}
.form-container {
  position: relative;
  width: 560px;
  height: 600px;
  background-color: #f5f7fa;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  .set-new-password {
    margin-top: 30px;
  }
}
.form-top {
  display: flex;
  margin-top: 47px;
  margin-bottom: 36px;
  .form-top-image {
    width: 100px;
    height: 97px;
    margin-left: -30px;
  }
  .form-top-right {
    margin-top: 28px;
    margin-left: 36px;
    margin-bottom: 0;
  }
  .form-top-letter-first {
    display: inline-block;
    line-height: 28px;
    color: #282a36;
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    margin-bottom: 8px;
  }
  .form-top-letter-second {
    height: 14px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #282a36;
    line-height: 14px;
  }
}
.validation {
  width: 410px;
  position: relative;
  overflow: hidden;
  .el-input__inner {
    background-color: red;
  }
}
.letter {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #505363;
}
.input {
  margin-top: 12px;
  background-color: red;
}
.alert-container {
  display: flex;
}
.alert-image {
  height: 14px;
}
.alert-text {
  position: relative;
  margin-left: 10px;
  margin-top: -2px;
  line-height: 18px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #9ea5b2;
}
.button {
  width: 100%;
  height: 40px;

  font-family: PingFangSC-Regular, PingFang SC;
  margin-top: 32px !important;
  margin-bottom: 19px !important;
  margin-top: 38px;
  font-size: 14px;
}
.form_warp {
  width: 100%;
  height: 100%;
  max-width: 560px;
  padding: 50px 75px;
  background: #f5f7fa;
  box-sizing: border-box;
  .warp_title {
    display: flex;
    align-items: center;
    .pass-icon {
      width: 100px;
      height: 96px;
    }
    .context_title_h1 {
      margin-bottom: 16px;
      padding-left: 0px !important;
    }
    .warp_title_warp {
      margin-left: 36px;
      display: flex;
      flex-direction: column;
    }
  }

  .dialog-footer {
    margin-top: 40px;
    text-align: center;
    .footer_btn {
      height: 38px;
      width: 100%;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
  }
}
html,
body,
#app {
  background-color: #f5f7fa;
}
.form-back-to-login {
  height: 300px;
}
</style>

<style lang="scss">
.validation,
.set-new-password {
  .el-input__inner {
    background-color: #f5f7fa;
  }
}
</style>
